// src/components/NotificationCard.tsx
import { FC, useEffect, useState, useContext, useCallback } from "react";
import { Stack, StackItem } from "@fluentui/react";
import {
	Text,
	Body1,
	Button,
	Divider,
	Card,
	Body1Stronger,
	Image,
	Caption2,
	Link,
	CardHeader,
	Body2,
	SkeletonItem,
	CardPreview,
	CardFooter,
	Body1Strong,
	Badge,
	PresenceBadge,
	Tooltip,
	Skeleton,
	FluentProvider,
	webLightTheme
} from "@fluentui/react-components";
import { Dismiss16Regular, CheckmarkCircleFilled, CheckmarkCircle20Regular } from "@fluentui/react-icons";
import client from '../../api/apollo';
import { getAuditLogsForOneQuery, getAuditLogsQuery } from '../../graphql/notifications_queries';
import { GlobalContext } from "../../hooks/globalContext";
import { notificationPosition, signFormPosition, skeleton1, skeleton11, skeleton3, skeleton4 } from "../../styles/customStyles";
import { useNavigate } from "react-router-dom";
import { updateViewedStatusQuery } from "../../graphql/activity_log_queries";
import apiCall from "../../utility/api";
import React from "react";
import { SkeletonNotifications } from "../skeleton/skeletonNotifications";

interface Notification {
	ID: string;
	summary: string;
	activity: string;
	action: string;
	pageName: string;
	initiatedBy: string;
	time: number;
}

interface NotificationCardProps {
	overlayopen: boolean;
	userRole: string;
	setOverlayOpen: any
}

const NotificationCard: FC<NotificationCardProps> = ({ overlayopen, userRole, setOverlayOpen }) => {
	const [notifications, setNotifications] = useState<Notification[]>([]);
	const [allNotifications, setAllNotifications] = useState<Notification[]>([]);
	const [isFetching, setIsFetching] = useState(false);
	const [hasFetchedData, setHasFetchedData] = useState(false);
	const [dismissAllButton, setDismissAllButton] = useState(false);
	const [dismissFewbutton, setDismissFewButton] = useState(false);
	const [loading, setLoading] = useState(true);
	const contextValue = useContext(GlobalContext);

	const userDetailsFromLocalStorage = JSON.parse(localStorage.getItem('userDetails') || '{}');
	const userid = userDetailsFromLocalStorage?.userid;
	const navigate = useNavigate();
	const getActivityLogFunc = async () => {
		// const { data, loading, error } = await client.query({
		//   query: getAuditLogsQuery,
		//   fetchPolicy: 'network-only',
		// });
		const whereCondition = { viewedStatus: "N" }
		try {
			let data = await apiCall('/activity/getList', { ...whereCondition });

			if (data?.status === 'success') {
				setLoading(false);
				if (data?.data.length > 0) {
					const firstTenLogs = data.data.slice(0, 10); // Get the first 10 elements
					setNotifications(firstTenLogs); // Set the notifications to the first 10 elements
					setAllNotifications(data.data);
					setDismissAllButton(true); // Enable the dismiss all button
					setDismissFewButton(true); // Enable the dismiss few button
				}
			}
			console.log("apiData=", data);
		} catch (error) {
			console.log("getCensusList error=", error);
		}

	}


	const getActivityLogForOneUser = async (userid: any) => {
		// userid = '221';
		userid = userid.toString();
		const whereCondition = { viewedStatus: "N", userId: userid }
		// const { data, loading, error } = await client.query({
		// 	query: getAuditLogsForOneQuery,
		// 	variables: { userid },
		// 	fetchPolicy: 'network-only',
		// });
		// console.log('usr role ' + userRole !== 'Admin')

		let { data, status } = await apiCall('/activity/getList', { ...whereCondition });
		if(status === 'success'){
			setLoading(false);
		}
		if (data?.length > 0 && (userRole !== 'Admin' && userRole !== 'Nanoheal-admin')) {
			const firstTenLogs = data?.slice(0, 10); // Get the first 10 elements
			setNotifications(firstTenLogs); // Set the notifications to the first 10 elements
			setAllNotifications(data)
			// console.log('notifications----------------------',JSON.parse(data.audit_ActivityLog[0].activity)?.summary)
		}
		// data.audit_ActivityLog.length > 0 && setDismissAllButton(true);
		if (data?.data?.length > 0) {
			setDismissAllButton(true); // Enable the dismiss all button
			setDismissFewButton(true); // Enable the dismiss few button
		}
	}


	const updateActivityLog = async (ID: any) => {
		setLoading(true);
		// const { data } = await client.mutate({
		// 	mutation: updateViewedStatusQuery,
		// 	variables: { ID },
		// 	fetchPolicy: 'network-only',
		// });
		try {
			const whereCondition = { ID: ID }
			let data = await apiCall('/activity/updateViewStatus', { ...whereCondition });
			if (data?.status == 'success') {
				console.log('notification view updated successfully')
				setLoading(false);
			} else {
				console.log('notification not view updated')
			}
		} catch (error) {
			console.log('error: ', error);
		}

	}
	const fetchActivityLog = async (userid: any) => {
		setLoading(true);
		if (overlayopen === true && (userRole === 'Admin' || userRole == 'Nanoheal-admin')) {
			getActivityLogFunc()
		} else if (overlayopen === true && userRole !== 'Admin' && userRole !== 'Nanoheal-admin') {
			console.log('userid -->', userid)
			getActivityLogForOneUser(userid)
		}
	}
	useEffect(() => {
		fetchActivityLog(userid);
	}, [overlayopen])

	useEffect(() => {
		console.log('notification -->', notifications);
		console.log('all notification -->', allNotifications);
	}, [notifications])

	const dismissNotification = async (id: string) => {
		setLoading(true);
		if (notifications.length == 1) {
			setDismissAllButton(false)
		}
		console.log('notifications.length ', notifications.length);
		setNotifications(notifications => notifications.filter(notification => notification.ID !== id));
		console.log('Viewed notification id ----------> ', id)

		await updateActivityLog([id]);
		fetchActivityLog(userid);
	};

	const dismissAllNotifications = async () => {
		// Ensure we wait for all updates to complete
		setLoading(true);
		var ids = allNotifications.map(notification => notification.ID)
		await updateActivityLog(ids);

		// Clear the notifications and update the state
		setNotifications([]);
		setDismissAllButton(false);
		setDismissFewButton(false);
		fetchActivityLog(userid);
	};

	const dismissFewNotifications = async () => {
		// Ensure we wait for all updates to complete
		setLoading(true);
		var ids = notifications.map(notification => notification.ID)
		await updateActivityLog(ids);

		// Clear the notifications and update the state
		setNotifications([]);
		setDismissFewButton(false);
		fetchActivityLog(userid);
	};

	const formatTimeElapsed = (UTCtime: number): string => {
		const now = Date.now();
		const notificationTime = UTCtime * 1000;
		const timeElapsed = Math.floor((now - notificationTime) / 1000);
		const minutes = Math.floor(timeElapsed / 60);
		const hours = Math.floor(minutes / 60);
		const days = Math.floor(hours / 24);
		const weeks = Math.floor(days / 7);

		if (weeks > 0) return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
		if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
		if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
		if (minutes > 1) return `${minutes} minutes ago`;
		if (minutes === 1) return `a minute ago`;
		if (timeElapsed > 30) return `a few minutes ago`;
		return `${timeElapsed} second${timeElapsed > 1 ? 's' : ''} ago`;
	}

	const renderNoNotifications = (module: any, page: any) => {
		if (module === 'Devices') {
			navigate('/manage/devices/activitylog');
		} else if (module === 'apps' || module === 'Apps') {
			navigate('/manage/user/activitylog');
		} else if (module === 'Users') {
			navigate('/manage/user/activitylog');
		} else if (module === 'Administration') {
			navigate('/manage/administration/activityLog');
		} else if (module === 'Automation') {
			navigate('/automate/automation/activitylog');
		} else if (module === 'troubleshoot') {
			navigate('/manage/user/activitylog');
		}
		setOverlayOpen(false);
	}

return (
  <>
    {loading ? (
        <SkeletonNotifications/>
    ) : (
      <>
        <Stack horizontalAlign="end" tokens={{ childrenGap: 10, padding: 10 }} horizontal>
          {dismissFewbutton && (
            <StackItem>
              <Tooltip
                withArrow
                content="Dismiss current page notifications"
                relationship="description"
                positioning="above"
              >
                <Link onClick={() => dismissFewNotifications()} aria-label="Dismiss">
                  Dismiss
                </Link>
              </Tooltip>
            </StackItem>
          )}
          {dismissAllButton && (
            <StackItem>
              <Tooltip
                withArrow
                content={`Dismiss all ${allNotifications.length} notifications`}
                relationship="description"
                positioning="above"
              >
                <Link onClick={() => dismissAllNotifications()} aria-label="Dismiss">
                  Dismiss all
                </Link>
              </Tooltip>
            </StackItem>
          )}
        </Stack>
        {notifications.length === 0 ? (
          <Stack tokens={{ childrenGap: 10 }} horizontalAlign="center">
            <Image src="/Dashboard/image/notificationBell.svg" />
            <Body1Stronger>No new notifications from this session</Body1Stronger>
            <Link /*onClick={dismissAllNotifications}*/ aria-label="Dismiss">
              {/* More Events in the Activity Log */}
            </Link>
          </Stack>
        ) : (
			notifications.map((notification: any) => (
				<>
				
				  <Divider />
				  <Stack tokens={{ childrenGap: 10 }}>              
	  
					<Card size="small" appearance="subtle" key={notification.ID}>
					  <CardHeader 
						header={<Button shape="circular"appearance="subtle" onClick={() => renderNoNotifications(notification.moduleName,notification.moduleName)}> {notification.status === 'Success' || notification.status === 'success' ? <PresenceBadge size="small"/> : <Badge appearance="filled" color="danger" size="small">!</Badge> } &nbsp; {notification.moduleName} : {notification.action} </Button>}
						action={
						  <Button
							onClick={() => dismissNotification(notification.ID)}
							aria-label="Dismiss"
							icon={<Dismiss16Regular />} // Changed to provide an icon
							style={{ marginLeft: "auto" }}
							appearance="transparent"
							size="small"
						  />
						}
					  />
					  <CardPreview>
						<Body1 wrap>
						&nbsp; &nbsp;&nbsp;&nbsp; {notification.activity.includes("summary") ? JSON.parse(notification.activity).summary != '' ? JSON.parse(notification.activity).summary + " by " + notification.initiatedBy : notification.action + " activity performed in " + notification.pageName + " page by " + notification.initiatedBy : notification.action + " activity performed in " + notification.pageName + " page by " + notification.initiatedBy}
						</Body1>
					  </CardPreview>
					</Card>
	  
	  
				  </Stack>
				  <Stack horizontalAlign="end" tokens={{ padding: 10 }}>
					<StackItem>
					  <Caption2>{formatTimeElapsed(notification.time)}</Caption2>
					</StackItem>
				  </Stack>
				</>
			  ))
        )}
      </>
    )}
  </>
);
};

export default NotificationCard;
